import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FloatingDialogService } from '../../../services/floating-dialog.service';
import { FloatingDialogContainerComponent } from '../floating-dialog-container/floating-dialog-container.component';

@Component({
  selector: 'app-floating-dialogs-host',
  standalone: true,
  imports: [AsyncPipe, FloatingDialogContainerComponent],
  templateUrl: './floating-dialogs-host.component.html',
  styleUrls: ['./floating-dialogs-host.component.scss'],
})
export class FloatingDialogsHostComponent {
  protected readonly service = inject(FloatingDialogService);
}
